<template>
	<div class="content">
		<base-header class="pb-6">
			<div class="row align-items-center py-4">
				<div class="col-lg-6 col-7">
					<h6 class="h2 text-white d-inline-block mb-0">
						{{ $t("po_form") }}
					</h6>
					<nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
						<route-bread-crumb></route-bread-crumb>
					</nav>
				</div>

				<div class="col-lg-6 col-5 text-right">
					<router-link to="/backoffice/po">
						<base-button size="md" type="neutral">{{
							$t("back")
						}}</base-button>
					</router-link>
				</div>
			</div>
		</base-header>

		<div class="row">
			<div class="container-fluid mt--6 col-lg-6">
				<div>
					<!-- card left -->
					<card header-classes="bg-transparent" footer-classes="bg-transparent" body-classes="px-lg-4 py-lg-4"
						class=" border-0  mb-4">
						<template slot="header">
							<div class="row">
								<label class="col-md-3 col-form-label form-control-label">
									<h3 class="mb-0">
										{{ $t("wms.partner") }}
									</h3>
								</label>

								<base-input class="col-auto">
									<el-select v-model="partner_id" filterable>
										<el-option v-for="option in PartnerTables" :key="option.id"
											:label="option.CompanyName" :value="option.ID"> </el-option> </el-select>
								</base-input>

								<div class="col-auto">

								</div>
							</div>
						</template>

						<validation-observer v-slot="{ handleSubmit }" ref="formValidator">
							<form class="needs-validation" @submit.prevent="handleSubmit(onSubmit)">

								<div class="form-group row">
									<div class="col-md-12">
										<base-input :label="$t('seller_note')" v-model="note"></base-input>
									</div>
								</div>

								<div class="row">
									<div class="col-md-12">
										<el-table :data="wms_selected" row-key="id" header-row-class-name="thead-light">
											<!-- Productname -->
											<el-table-column> <template slot-scope="{ $index, row }"> {{
												row.product_name }} </template>
											</el-table-column>
											<!-- skuname -->
											<el-table-column>
												<template slot-scope="{ $index, row }"> {{ row.sku_code }} </template>
											</el-table-column>

											<!-- quantity -->
											<el-table-column>
												<template slot-scope="{ $index, row }">
													<base-button @click.native=" handleProductAdd($index)" class="edit"
														type="warning" size="sm" icon>
														<i class="text-dtac-bt fa fa-plus"></i>
													</base-button>

													<input @keydown="CheckIsNumber" @input="convertNumber(row)"
														type="text" class="form-control text-center"
														style="display:inline; width:30%; margin-right:10px"
														v-model="row.quantity">
													<!-- <span class="px-3"> {{ row.quantity }} </span> -->

													<base-button @click.native=" handleProductRemove($index)"
														class="edit" type="warning" size="sm" icon>
														<i class="text-dtac-bt fa fa-minus"></i>
													</base-button>
												</template>
											</el-table-column>
										</el-table>
									</div>
								</div>



								<div class="form-group row">

									<hr />
									<div class="col-md-12 mt-3">
										<base-button size="md" type="primary" :loading="isLoading"
											@click="handleSave()">{{ $t("save")
											}}</base-button>
									</div>


								</div>


								<div class="form-group row mt--6" v-for="item in ProductSelect" :key="item.ID">
									<label class="col-md-6 pl-6 col-form-label form-control-label">
										{{ item.Name }}
									</label>
									<div class="col-md-3">
										<base-button @click.native=" handleDelete($index, item)"
											class="remove btn-link" type="danger" size="md" icon> <i
												class="text-dtac-bt fa fa-trash"></i> </base-button>
									</div>
								</div>
							</form>
						</validation-observer>
					</card>
				</div>
			</div>

			<div class="container-fluid mt--6 col-lg-6">
				<div>
					<!-- card right -->
					<card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2">
						<template slot="header">
							<div class="row">
								<label class="col-md-6 col-form-label form-control-label">
									<h3 class="mb-0"> {{ $t("product_information") }} </h3>
								</label>
								<div class="col-md-6">
									<base-input v-model="SearchKeyword" prepend-icon="fas fa-search"
										:placeholder="$t('search')"> </base-input>
								</div>
							</div>
						</template>
						<div>
							<!-- Selected Product -->
							<el-table :data="queriedData" row-key="id" header-row-class-name="thead-light"
								@sort-change="sortChange" @selection-change="selectionChange">
								<el-table-column>
									<template slot-scope="{ $index, row }">
										<div class="row">
											<div class="col-md-3">
												<img :src="GetProductUrl(row.images)" width="100px" height="100px" />
											</div>
											<div class="col-md-7"> {{ row.name }} </div>
											<div class="col-md-2">
												<base-button @click.native="handleAddProductSelect(row)" class="edit"
													type="warning" size="sm" icon>
													<i class="text-dtac-bt fa fa-plus"></i>
													{{ " " + $t("add") }}
												</base-button>

											</div>
										</div>
									</template>
								</el-table-column>
							</el-table>
						</div>
						<div slot="footer"
							class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
							v-if="queriedData.length != 0">
							<div class="">
								<p class="card-category">
									{{ $t("data") }} {{ from + 1 }}
									{{ $t("to") }} {{ to }}
									{{ $t("of") }}
									{{ total }}
									<span v-if="selectedRows.length">
										- &nbsp; &nbsp;
										{{ selectedRows.length }}
										{{ $t("row_select") }}
									</span>
								</p>
							</div>
							<base-pagination class="pagination-no-border" v-model="pagination.currentPage"
								:per-page="pagination.perPage" :total="total">
							</base-pagination>
						</div>
					</card>
				</div>
			</div>
		</div>

		<!--  Modal -->
		<modal :show.sync="showSkuModal" modal-classes="modal-secondary">
			<form class="new-event--form" @submit.prevent="saveEvent">
				Product : {{ product.name }}

				<!-- Loop atrribute -->

				<div v-for="(attribute, index) in product.attributes" :key="index" class="row py-2">
					<div class="col-md-6 col-lg-6">
						<base-input :value="attribute.variable" size="sm" />
					</div>

					<div class="col-md-6 col-lg-6">
						<base-input>
							<el-select v-model="product_variable_select[index]" :placeholder="$t('product')"
								:label="$t('product')" value-key="name">
								<template v-for="(option) in attribute.options">
									<el-option :key="option.name"
										:label="option.name + ' (' + GetStockBalance(option) + ')'" :value="option"
										class="text-red" v-if="GetStockBalanceIsLock(option)" />
									<el-option :key="option.name"
										:label="option.name + ' (' + GetStockBalance(option) + ')'" :value="option"
										v-else />
								</template>
							</el-select>
						</base-input>
					</div>

				</div>
			</form>


			<div class="row" v-if="ProductVariableCheck != ''">
				<div class="col-md-12">
					<!-- Text warining -->
					<div class="alert alert-warning" role="alert">
						{{ ProductVariableCheck }}
					</div>
				</div>
			</div>


			<template slot="footer">
				<button v-if="ProductVariableCheck == ''" type="submit" class="btn btn-md btn-primary"
					@click="handleAddProductSkuSelect()">
					{{ $t("add") }}
				</button>

				<button type="button" class="btn btn-md btn-link ml-auto" @click="showSkuModal = false">
					{{ $t("close") }}
				</button>
			</template>
		</modal>
	</div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "../PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";
import FileInput from "@/components/Inputs/FileInput";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import PartnerTables from "../Stock/PartnerTables.vue";

export default {
	mixins: [clientPaginationMixin],
	components: {
		flatPicker,
		FileInput,
		BasePagination,
		RouteBreadCrumb,
		[Select.name]: Select,
		[Option.name]: Option,
		[Table.name]: Table,
		[TableColumn.name]: TableColumn
	},
	computed: {
		...mapGetters({
			tableData: "WmsProduct/getData",
			isAgent: "Auth/isAgent",
			getUser: "Auth/getUser",
			Stock: "WmsProduct/getInventortySummary",
			PartnerTables: "WmsPartner/getData",

		}),
	},
	watch: {


	},
	data() {
		return {
			results: [],
			isLoading: false,

			tableColumns: [],
			wms_selected: [],
			partner_id: "",
			showSkuModal: false,

			SearchKeyword: "",
			ProductSelect: [],

		};
	},
	async mounted() {

		this.listStock();
		this.listWMS();
		this.listPartner();


	},
	methods: {
		...mapActions({
			listPartner: "WmsPartner/listData",
			listWMS: "WmsProduct/listData",
			listProduct: "Product/listData",
			listStock: "WmsProduct/listWmsInventorySummary"
		}),
		async handleSave() {
			// console.log("handle save");
			let valid = await this.$refs.formValidator.validate();
			if (!valid) return;

			if (this.wms_selected.length == 0) {
				swal.fire({
					text: "",
					title: "กรุณาเลือกสินค้า",
					icon: "error",
					confirmButtonClass: "btn btn-danger btn-fill",
					buttonsStyling: false
				});
				return;
			}

			if (this.params.bo_payment_method_id == 0 || this.params.bo_payment_method_id == "") {
				swal.fire({
					text: "",
					title: "กรุณาเลือกช่องทางการชำระเงิน",
					icon: "error",
					confirmButtonClass: "btn btn-danger btn-fill",
					buttonsStyling: false
				});
				return;
			}

			if (this.params.payment_at == "" && !this.IsCOD) {
				swal.fire({
					text: "",
					title: "กรุณาระบุวันที่ชำระเงิน",
					icon: "error",
					confirmButtonClass: "btn btn-danger btn-fill",
					buttonsStyling: false
				});
				return;
			}

			// Check discount
			let discountFloat = parseFloat(this.params.discount)

			if (isNaN(discountFloat)) {
				swal.fire({
					text: "",
					title: "ส่วนลดไม่ถูกต้อง",
					icon: "error",
					confirmButtonClass: "btn btn-danger btn-fill",
					buttonsStyling: false
				});
				return
			}

			var regIsMobileNumber = /^[0]\d{9}$/g;
			if (!regIsMobileNumber.test(this.params.recipient_phone)) {
				swal.fire({
					title: "เบอร์โทรศัพท์ไม่ถูกต้อง",
					text: "",
					icon: "error",
					confirmButtonClass: "btn btn-danger btn-fill",
					buttonsStyling: false
				});
				return
			}

			try {
				let resp = await this.createData(this.params);
				console.log(resp)
				console.log("D")
				this.isLoading = false
				swal.fire({
					title: this.$t("create_success"),
					text: ``,
					icon: "success",
					confirmButtonClass: "btn btn-success btn-fill",
					buttonsStyling: false
				}).then(() => {
					//  Clear Param
					// goto order page
					this.$router.push({ name: "BOPo", params: { detail: resp.data.Datum } });
				}).catch(err => {
					console.log("E")
					console.log(err)
				});
			} catch (err) {
				console.log("F")
				this.isLoading = false
				swal.fire({
					title: this.$t(err.response.data.Msg),
					text: this.getErrorText(err.response.data),
					icon: "error",
					confirmButtonClass: "btn btn-danger btn-fill",
					buttonsStyling: false
				});
			}
		},


		handleProductAdd(index) {
			this.wms_selected[index].quantity += 1;
		},
		handleProductRemove(index) {
			this.wms_selected[index].quantity -= 1;

			if (this.wms_selected[index].quantity == 0) {
				this.wms_selected.splice(index, 1);
			}
		},

		handleDelete(index, row) {
			swal.fire({
				title: this.$t("delete_confirm"),
				text: this.$t("delete_confirm_question") + row.Name,
				icon: "warning",
				showCancelButton: true,
				confirmButtonClass: "btn btn-success btn-fill",
				cancelButtonClass: "btn btn-danger btn-fill",
				confirmButtonText: this.$t("confirm"),
				cancelButtonText: this.$t("cancel"),
				buttonsStyling: false
			}).then(result => {
				//  let index = this.ProductSelect.indexOf(row)
				this.ProductSelect.splice(index, 1);
			});
		},

		GetStockBalance(option) {

			let stock = this.getStock.filter(s => {
				return s.product_id == option.wms_map[0].wms_product_id
			})

			if (stock.length == 0) {
				return 0
			}

			return stock[0].balance
		},

		GetStockBalanceIsLock(option) {

			let stock = this.getStock.filter(s => {
				return s.product_id == option.wms_map[0].wms_product_id
			})

			if (stock.length == 0) {
				console.log("Stock Not found", option.wms_map[0].wms_product_id)
				return true
			}

			return stock[0].balance <= stock[0].threshold
		},
	}
};
</script>
<style>
.autocomplete {
	position: relative;
}

.autocomplete-results {
	padding: 0;
	margin: 0;
	border: 1px solid #eeeeee;
	height: 120px;
	min-height: 1em;
	max-height: 6em;
	overflow: auto;
}

.autocomplete-result {
	list-style: none;
	text-align: left;
	padding: 4px 2px;
	cursor: pointer;
}

.autocomplete-result:hover {
	background-color: #01659e;
	color: white;
}

.autocomplete-result.is-active,
.autocomplete-result:hover {
	background-color: #4aae9b;
	color: white;
}

.product-tag {
	/* background-color: #c1d1fa; */
	/* z-index: 1000;
  transform: scale(1.5) perspective(1px) */
	font-size: 1.1rem
}
</style>
